import { isNil } from "lodash";
import { useMemo } from "react";
import { useRootStore } from "../stores/RootStoreContext";

export type QueryParams = Record<string, string | undefined>;

export function toQueryString(params: { [key: string]: unknown } | undefined): string {
  if (!params) {
    return "";
  }
  const s = new URLSearchParams(
    Object.entries(params)
      .filter(([, v]) => !isNil(v))
      .map(([k, v]) => [k, String(v)]),
  ).toString();
  return s ? `?${s}` : "";
}

export function fromQueryString(s: string | undefined): QueryParams {
  return Object.fromEntries(new URLSearchParams(s ?? "").entries());
}

export function useQuery() {
  const { search } = useRootStore().location;
  return useMemo(() => new URLSearchParams(search), [search]);
}

export function stripQueryString(s: string) {
  let end = s.indexOf("?");
  if (end === -1) {
    end = s.length;
  }
  return s.substring(0, end);
}
